// extracted by mini-css-extract-plugin
module.exports = {"StatisticCharts":"Graphs_StatisticCharts__31vtn","ChartSize":"Graphs_ChartSize__3iyYc"};